import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import store from '@/store'

export const useRolesStore = defineStore('roles', {
  state: () => ({
    roles: [],
    fetchInitiated: false
  }),

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/roles')
        .then(response => {
          this.roles = response.data.roles
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    }
  }
})
